import React from 'react'
import NavLink from './nav-link'

const HorMenu = () => (
  <div className='hor-menu'>
    <ul className='nav navbar-nav'>
      <NavLink to='/'>Dashboard</NavLink>
      <NavLink to='/my-experiences'>My Experiences</NavLink>
      <NavLink to='/explore-experiences'>Explore Experiences</NavLink>
    </ul>
  </div>
)

HorMenu.displayName = 'HorMenu'

export default HorMenu



// WEBPACK FOOTER //
// ./src/components/header/hor-menu.js